import { render, staticRenderFns } from "./MenuItemsEditorEntreeDetails.vue?vue&type=template&id=0d207434&scoped=true&"
import script from "./MenuItemsEditorEntreeDetails.vue?vue&type=script&lang=js&"
export * from "./MenuItemsEditorEntreeDetails.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemsEditorEntreeDetails.vue?vue&type=style&index=0&id=0d207434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d207434",
  null
  
)

export default component.exports